<section tiptapDraggable [ngClass]="{ editable: isEditable, selected: isEditable && isSelected }">
    <span> Guest registration link</span>
    <mat-form-field class="full-width" appearance="outline">
        <input readonly="readonly" matInput [value]="zoomMeeting?.topic || 'No Meeting Selected'" />
        <button matSuffix mat-icon-button aria-label="Copy" >
            <mat-icon>content_copy</mat-icon>
        </button>
    </mat-form-field>
</section>
